// Copyright (c) 2017 Deere & Company

import DebitPartsPanel from './debit-parts-panel';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    adjustmentTypes: state.tcsm.partialDebit.adjustmentTypes.filter(adjustmentType => adjustmentType.key !== '03' && adjustmentType.key !== '04'),
    isEditable: true,
    parts: state.tcsm.partialDebit.debit.getParts()
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const {updateAdjustmentType, updateAdjustmentValue} = dispatchProps;

    return {
        ...stateProps,
        actions: {
            updateAdjustmentType,
            updateAdjustmentValue
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(DebitPartsPanel);



// WEBPACK FOOTER //
// ./src/tcsm/partial-debit/components/debit-parts-panel/index.js